export default __webpack_public_path__ + "fd62c6c08af25e38de8926d6be8dda3c.png";